/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const SACHSENTRANC: CommunityData = {
  code: "sachsentrance",
  inviteCode: "sachsentrance",
  name: "Sachsentrance",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sac-808`,
  waitlist: false,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#6144f4",
      hero: {
        desktop:
          "https://media.werz.at/community-assets/SACHSENTRANC/coming-soon-hero.mp4?type=video",
        mobile:
          "https://media.werz.at/community-assets/SACHSENTRANC/coming-soon-hero.mp4?type=video",
        style: "bg-[#5338b0]",
      },
      logo: {
        desktop: "https://media.werz.at/community-assets/SACHSENTRANC/web-logo.png",
        mobile: "https://media.werz.at/community-assets/SACHSENTRANC/web-logo.png",
        style: "w-[92px] h-[78px] sm:w-[156px] sm:h-[133px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['PixellariMedium'] text-[28px] leading-[120%] text-[#effd71] uppercase",
      text: "font-['MondaRegular'] text-[16px] leading-[120%] text-[#effd71]",
      button:
        "font-['PixellariMedium'] text-[14px] leading-[120%] uppercase p-4 bg-[#effd71] text-[#000000] cursor-pointer w-fit shadow-[6px_6px_0px_0px_#3C209C]",
      input: {
        base: "font-['MondaRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#5338b0] text-[#effd71]",
        border: "#7a66d4",
        borderFocus: "#effd71",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['MondaRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['MondaRegular'] text-[14px] leading-[120%] text-[#a999e8]",
      skipButton: "font-['MondaRegular'] text-[14px] leading-[120%] text-[#a999e8] cursor-pointer",
      modal: {
        container: "bg-[#5338b0] px-[40px] py-[48px]",
        title:
          "font-['PixellariMedium'] text-[24px] leading-[120%] text-[#effd71] text-center uppercase",
        text: "font-['MondaRegular'] text-[14px] leading-[120%] text-[#a999e8] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#effd71] bg-[#6144f4] font-['MondaRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#7a66d4",
        otpBorderFocus: "#effd71",
      },
    },
    global: {
      counterColor: "#effd71",
      logo: {
        src: "https://media.werz.at/community-assets/SACHSENTRANC/web-logo.png",
        styles: "w-[156px] h-[132.77px]",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/SACHSENTRANC/web-alternative-logo.png",
        styles: "w-[156px] h-[132.77px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#6144f4",
      asideBg: "#5338b0",
      asideStyles: "bg-[#5338b0] border-r border-[#effd71]",
      contentBg: "#6144f4",
      contentBoxShadow: "",
      bgDesktop: "https://media.werz.at/community-assets/SACHSENTRANC/web-background.jpg",
      bgMobile: "https://media.werz.at/community-assets/SACHSENTRANC/web-background-mobile.jpg",
      nonMemberBg:
        "https://media.werz.at/community-assets/SACHSENTRANC/web-background-non-member.png",
      mainFont: "font-['MondaRegular']",
      primaryButton:
        "bg-[#effd71] border border-[#effd71] px-[18px] py-[18px] !text-[#000000] font-['PixellariMedium'] !text-[18px] uppercase text-left shadow-[6px_6px_0px_0px_#3C209C]",
      scrollArrow: {
        background: "#effd71",
        color: "#000000",
      },
    },
    navigation: {
      iconsColor: "#effd71",
      sideBarSeparator: "border-r border-[#effd71]",
      separator: "#effd71",
      item: "text-[#effd71] font-['PixellariMedium'] text-[16px] uppercase text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#effd71] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "bg-[#6144f4] border border-[#effd71] !pb-8",
      titles: "text-[#effd71] font-['PixellariMedium'] text-[26px] uppercase text-left",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#effd71] font-['MondaRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#effd71]",
        sectionTitle:
          "text-[#effd71] font-['PixellariMedium'] text-[26px] uppercase text-left pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container: "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px]",
          mediaContainer:
            "w-full sm:w-[256px] !aspect-square relative shadow-[6px_6px_0px_0px_#3C209C]",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#effd71] font-['PixellariMedium'] text-[16px] uppercase text-left",
          subtitle:
            "text-[#effd71] font-['MondaRegular'] text-[12px] text-left leading-[120%] mt-1",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#effd71]",
        sectionTitle:
          "text-[#effd71] font-['PixellariMedium'] text-[26px] uppercase text-left pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[134px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full bg-[#ffffff00]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 sm:!h-[128px] relative shadow-[6px_6px_0px_0px_#3C209C]",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "text-[#effd71] font-['PixellariMedium'] sm:text-[16px] text-left text-[24px] uppercase",
          subtitle: "text-[#effd71] font-['MondaRegular'] text-[12px] text-left leading-[120%]",
          location: "text-[#effd71] font-['MondaRegular'] text-[12px] text-left leading-[120%]",
          date: "text-[#effd71] font-['MondaRegular'] text-[12px] text-left leading-[120%]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0",
        title: "text-[#effd71] font-['PixellariMedium'] text-[24px] uppercase text-left",
        text: "text-[#effd71] font-['MondaRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#effd71] font-['PixellariMedium'] text-[24px] uppercase text-left !mb-4 sm:!mb-4",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#6144f4] border border-[#effd71] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media:
          "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 shadow-[6px_6px_0px_0px_#3C209C] !border-0",
        title: "text-[#effd71] font-['PixellariMedium'] text-[26px] uppercase text-left",
        subtitle:
          "text-[#effd71] font-['MondaRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#effd71] border border-[#effd71] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['PixellariMedium'] text-[18px] uppercase text-left shadow-[6px_6px_0px_0px_#3C209C]",
        questions: "text-[#effd71] font-['MondaRegular'] text-[14px] text-left leading-[120%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#effd71]",
        header: "text-[#effd71] font-['PixellariMedium'] text-[24px] uppercase text-left",
        text: "text-[#effd71] font-['MondaRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#effd71]",
        header: "text-[#effd71] font-['PixellariMedium'] text-[24px] uppercase text-left",
        text: "text-[#effd71] font-['MondaRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] border-b border-[#effd71] shadow-[6px_6px_0px_0px_#3C209C]",
        mapPinColor: "#6144f4",
        mapStrokeColor: "#effd71",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#effd71] font-['PixellariMedium'] text-[24px] uppercase text-left",
        text: "text-[#effd71] font-['MondaRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#effd71] font-['PixellariMedium'] text-[26px] uppercase text-left px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#6144f4] !pb-8",
        innerContainer: "flex flex-col px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#effd71] border border-[#effd71] px-4 py-3 text-[#000000] font-['PixellariMedium'] text-[14px] uppercase text-left !w-fit shadow-[6px_6px_0px_0px_#3C209C]",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto py-4 mb-4 border-b border-[#effd71]",
          media: "!hidden",
          name: "text-[#effd71] font-['PixellariMedium'] text-[16px] uppercase text-left",
          description:
            "text-[#effd71] font-['MondaRegular'] text-[14px] text-left leading-[120%] !mt-1",
          price: "text-[#effd71] font-['PixellariMedium'] text-[16px] uppercase text-left !mt-1",
          quantity: "text-[#000000] font-['PixellariMedium'] text-[14px] uppercase text-left mt-1",
          status: "text-[#effd71] font-['PixellariMedium'] text-[16px] uppercase text-left",
          counterContainer:
            "bg-[#effd71] border border-[#effd71] px-4 py-3 gap-x-4 !w-fit !h-10 shadow-[6px_6px_0px_0px_#3C209C]",
          button:
            "!bg-[#effd71] border border-[#effd71] px-4 py-3 text-[#000000] font-['PixellariMedium'] text-[14px] uppercase text-left !w-fit shadow-[6px_6px_0px_0px_#3C209C]",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default SACHSENTRANC
